@let isMobile = breakpoints() === "mobile";
<section class="form-layout-2">
  <div class="container">
    <div class="row">
      <div class="col-lg-9 col-xs-12">
        <app-title [titles]="[title()]" class="title" />
      </div>
      <div class="col-lg-12 col-xs-12 content">
        <div class="form">
          <div class="step step-one">
            <div class="form-item">
              <div>
                <span>Heureux de vous rencontrer</span>
                <div class="form-item-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{ width: isMobile ? '19.5rem' : '38rem' }"
                    [debounceTime]="1000"
                    [specs]="specs()[0]!"
                    [theme]="'DASHED'" />
                  <span class="dot">.</span>
                </div>
              </div>
            </div>
          </div>
          @if (0 | isStepVisible: form) {
            <div @fadeInOut class="step step-two">
              <div class="form-item">
                <div>
                  <span>Pourriez-vous nous en dire plus sur votre projet de rejoindre Perene :</span>
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: isMobile ? '28rem' : '55.5rem' }"
                      [isMobile]="isMobile"
                      [specs]="specs()[1]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
              </div>
              <div class="form-item">
                <div>
                  <span>Vous souhaitez ouvrir une boutique à proximité de </span>
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: isMobile ? '11rem' : '21.5rem' }"
                      [isMobile]="isMobile"
                      [specs]="specs()[2]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (1 | isStepVisible: form) {
            <div @fadeInOut class="step step-four">
              <div class="form-item">
                <div>
                  Vous souhaitez être contacté
                  @if (isMobile) {
                    <br />
                  }
                  <span>au </span>
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: isMobile ? '25.5rem' : '49.5rem' }"
                      [debounceTime]="1000"
                      [specs]="specs()[3]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (2 | isStepVisible: form) {
            <div @fadeInOut class="step step-five">
              <div class="form-item">
                <div>
                  <span>Et à l’adresse </span>
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: isMobile ? '19.5rem' : '38.5rem' }"
                      [isMobile]="isMobile"
                      [specs]="specs()[4]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (3 | isStepVisible: form) {
            <div @fadeInOut class="step step-six">
              <app-button
                (buttonClicked)="onSuccess()"
                [icon]="{ name: 'CHEVRON_RIGHT' }"
                [isLoading]="isSending()"
                [label]="'Envoyer'"
                [theme]="'FULL_WHITE'" />
              <div role="alert">
                @if (isSendFailed()) {
                  <div class="error error-dashed">
                    Votre demande n'a pas pu être envoyée. Réessayez ou contactez votre boutique.
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <p class="infos">
          Les informations qui vous concernent sont destinées exclusivement à FOURNIER SA. Vous disposez d'un droit
          d'accès, de modification, de rectification et de suppression des données qui vous concernent. Pour l'exercer,
          écrivez à : Société FOURNIER - B.P. 22 - 74230 Thônes - FRANCE. Pour connaître l’utilisation que nous faisons
          des données collectées par ce formulaire et exercer vos droits sur vos données personnelles, notamment en
          matière d’accès et de suppression, veuillez consulter notre charte de confidentialité
        </p>
      </div>
    </div>
  </div>
</section>
